const sepia = {
    name: "sepia",
    path: "/sepia",
    title: "sepia",
    description: "Utilities for applying sepia filter effects to elements.",
    value: {
        'filter': {
            'sepia': 'sepia(100%)',
            'sepia-<number>': 'sepia(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "sepia-50, sepia-100",
            "description": "to control an element's sepia:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg sepia-0",
                        "text": "sepia-0",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg sepia-50",
                        "text": "sepia-50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg sepia",
                        "text": "sepia",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="sepia-0" src="/img/mountains.jpg" />
<img class="sepia-50" src="/img/mountains.jpg" />
<img class="sepia" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default sepia;